
export const NAME_REDUCER = 'apt';

export const PREFIX_ACTIONS = 'apt_feature_';


export const PATH_LOADING = {
  getData: `loading.${NAME_REDUCER}.getData`,
};
